import * as React from "react";
import * as Article from "@elevio/kb-kit/lib/components/article";
import { useTranslation } from "@elevio/kb-kit/lib/hooks";
import { getHeader } from "./home";
import PageLayout from "../components/layouts/Page";
import Footer from "../components/Footer";
import WithAsideLayout, { Aside, Main, MainHeader, MainBody, } from "../components/layouts/WithAside";
import ArticleList from "../components/ArticleList";
import ArticleMeta from "../components/ArticleMeta";
import ArticleActions from "../components/ArticleActions";
import ArticleFeedback from "../components/ArticleFeedback";
import { getAssetURL } from "@elevio/kb-kit/lib/utils/globals";
import { fetchAgencyFlags } from "../requests/agency-flags";
import { privateSubmissionUrl } from "../utils/privateSubmissionUrl";
const AGENCY_ID = 9;
function Page() {
    const { t } = useTranslation();
    const [showViewAllRequests, setShowViewAllRequests] = React.useState(false);
    React.useEffect(() => {
        let cancelled = false;
        fetchAgencyFlags(AGENCY_ID).then((data) => {
            if (!cancelled) {
                setShowViewAllRequests(Boolean(data === null || data === void 0 ? void 0 : data.isPublicMapEnabled));
            }
        });
        return () => {
            cancelled = true;
        };
    }, []);
    const openPrivateSubmission = (path) => {
        const url = privateSubmissionUrl(path);
        if (!url) {
            return;
        }
        const newWindow = window.open(url, "_blank");
        if (newWindow) {
            newWindow.opener = null;
        }
    };
    const handleSubmitRequest = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("create");
    };
    const handleViewMyRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("listing");
    };
    const handleViewAllRequests = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openPrivateSubmission("public-map");
    };
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <div className="sedalia-logo-wrapper">
      </div>
      <section className="button-container button-container--three">
        <div className="button-wrapper">
          <button type="button" className="cta-request" onClick={handleSubmitRequest}>
            <img src={getAssetURL("images/request.svg")} alt="request icon" aria-hidden/>
            Submit a Request
          </button>
        </div>
        <div className="button-wrapper">
          <button type="button" className="cta-request" onClick={handleViewMyRequests}>
            <img src={getAssetURL("images/inbox.svg")} alt="inbox icon" aria-hidden/>
            View My Requests
          </button>
        </div>
        {showViewAllRequests ? (<div className="button-wrapper">
            <button type="button" className="cta-request" onClick={handleViewAllRequests}>
              <img src={getAssetURL("images/map.svg")} alt="map icon" aria-hidden/>
              View All Requests
            </button>
          </div>) : null}
      </section>
      <WithAsideLayout>
        <Main>
          <MainHeader>
            <ArticleActions />
            <h1 className="main-title" data-testid="article-title">
              <Article.Title />
            </h1>
            <ArticleMeta />
          </MainHeader>

          <MainBody>
            <Article.Body />
          </MainBody>
          <ArticleFeedback />
        </Main>

        <Aside>
          <ArticleList isRelated isAside/>
        </Aside>
      </WithAsideLayout>
    </PageLayout>);
}
export default Page;
